import { isApprover, isUploaderAllowed } from './AccessUtilities';
import { FRISCO_ROLE_RESTRICTED_APP_IDS } from './Constants';
import appSettings from '../CorpReporting/app_settings';

const PROCESS_ROLE_POLICY = {
  id: 'process-roles-required',
  applies: ({ appId, currentStage }) =>
    FRISCO_ROLE_RESTRICTED_APP_IDS[currentStage]?.includes(String(appId))
    && (appSettings[currentStage]?.appId == null
      || String(appSettings[currentStage].appId) !== String(appId)),
  evaluate: async ({ processData, userId, currentStage, userLDAPS }) => {
    const [isUploader, isApproverUser] = await Promise.all([
      isUploaderAllowed(processData, userId, currentStage, userLDAPS),
      isApprover(processData, userId, currentStage, userLDAPS)
    ]);

    return {
      canUpload: isUploader,
      canViewHistory: isUploader || isApproverUser,
      hasUploaderAccess: isUploader,
      uploadDeniedReason: "You don't have permission to perform an upload action. You are not part of the Uploader group for this deliverable. If you believe you should have access, contact the process owner.",
      historyDeniedReason: "You don't have permission to view the history. You are not part of the Uploader/Approver group for this deliverable. If you believe you should have access, contact the process owner."
    };
  }
};

export const FRISCO_ACCESS_POLICIES = [PROCESS_ROLE_POLICY];

export const getApplicableFriscoAccessPolicies = (context) =>
  FRISCO_ACCESS_POLICIES.filter((policy) => policy.applies(context));

export const hasFriscoAccessRestrictions = (context) =>
  getApplicableFriscoAccessPolicies(context).length > 0;

export const resolveFriscoAccess = async (context) => {
  const policies = getApplicableFriscoAccessPolicies(context);
  if (policies.length === 0) {
    return { isRestricted: false, canUpload: true, canViewHistory: true };
  }

  const results = await Promise.all(policies.map((policy) => policy.evaluate(context)));
  const deniedUpload = results.find((result) => result.canUpload === false);
  const deniedHistory = results.find((result) => result.canViewHistory === false);

  return {
    isRestricted: true,
    policyIds: policies.map((policy) => policy.id),
    canUpload: !deniedUpload,
    canViewHistory: !deniedHistory,
    hasUploaderAccess: results.every((result) => result.hasUploaderAccess !== false),
    uploadDeniedReason: deniedUpload?.uploadDeniedReason,
    historyDeniedReason: deniedHistory?.historyDeniedReason
  };
};